var _path, _path2, _path3, _g, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1F60B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDD67",
    d: "M62 31.996C62 48.566 48.566 62 32 62 15.432 62 2 48.566 2 31.996 2 15.434 15.432 2 32 2c16.566 0 30 13.428 30 29.996z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF717F",
    d: "M42.004 47.881c-5.027-5.027-2.777-2.779 2.525-8.082 5.307-5.301 3.055-7.553 8.082-2.527 5.023 5.027 5.174 9.926 2.244 12.855-2.929 2.928-7.826 2.779-12.851-2.246z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2596C",
    d: "M45.59 38.738l6.849 8.973-8.97-6.852z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#664E27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.526 24.854c-1.859-5.111-4.66-7.669-7.461-7.669s-5.602 2.558-7.461 7.669c-.184.515.775 1.443 1.254.938 1.803-1.901 3.957-2.658 6.207-2.658s4.404.757 6.207 2.658c.479.506 1.438-.423 1.254-.938zM50.396 24.854c-1.859-5.111-4.66-7.669-7.461-7.669s-5.602 2.558-7.461 7.669c-.184.515.775 1.443 1.254.938 1.803-1.901 3.957-2.658 6.207-2.658s4.404.757 6.207 2.658c.478.506 1.437-.423 1.254-.938z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#664E27",
    d: "M48.11 33.02c-4.328 6.107-9.451 7.644-16.11 7.644s-11.782-1.536-16.11-7.644c-.604-.85-2.19-.315-1.84.919 2.273 8.005 10 12.668 17.95 12.668s15.677-4.663 17.95-12.668c.351-1.235-1.236-1.769-1.84-.919z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1F60B);
export default __webpack_public_path__ + "static/media/1f60b.666280811d9ec31d0ca71bb6479cff12.svg";
export { ForwardRef as ReactComponent };